import { Component, computed, inject, Signal } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { TellentGroupKind, TellentMember } from '@core/tellent-types';
import {
  AvatarComponent,
  BoxComponent,
  ButtonComponent,
  DialogBodyComponent,
  DividerComponent,
  EmptyStateComponent,
  HeadingComponent,
  IconComponent,
  TruncateComponent,
} from '@core/user-interface-legacy';

import {
  EditMemberGroupsTabController,
  GROUP_KIND,
} from '../edit-member-groups-tab/edit-member-group-tab.controller';
import { EditMemberGroupsTabService } from '../edit-member-groups-tab/edit-member-group-tab.service';

@Component({
  selector: 'edit-member-departments-tab',
  imports: [
    AvatarComponent,
    BoxComponent,
    ButtonComponent,
    DividerComponent,
    EmptyStateComponent,
    HeadingComponent,
    IconComponent,
    TranslatePipe,
    TruncateComponent,
    DialogBodyComponent,
  ],
  templateUrl: './edit-member-departments-tab.component.html',
  styleUrl: './edit-member-departments-tab.component.less',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: EditMemberDepartmentsTabComponent.NgInputs,
  viewProviders: [
    EditMemberGroupsTabService,
    EditMemberGroupsTabController,
    {
      provide: GROUP_KIND,
      useValue: TellentGroupKind.Department,
    },
  ],
})
export class EditMemberDepartmentsTabComponent {
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  public static NgInputs = ['memberGuid' as const];
  protected readonly vm = inject(EditMemberGroupsTabController);
  protected memberGuid: string;

  protected memberData: Signal<TellentMember | null>;
  protected departments = computed(() =>
    this.memberData()?.teams.filter(team => team.kind === TellentGroupKind.Department),
  );
  protected noDepartments = computed(() => {
    const teams = this.departments();
    return teams && teams.length === 0;
  });
  protected sortedDepartments = computed(() => {
    const departments = this.departments();
    return departments
      ? [...departments].sort((a, b) => b.assignedAt.localeCompare(a.assignedAt))
      : [];
  });

  protected ngOnInit() {
    this.memberData = this.vm.memberData(this.memberGuid);
  }
}
